import {ComponentElementPropertyType} from "../ComponentElementManifest.model";
import {AutoCompleteSearchField, LookUpAutoCompleteSearchField} from "../../data_set/LookUp.model";

export const LookUpFilterKeyConstant = "___lookupFilter";
export const LookUpFilterConstant = {
    label: "Result Filter",
    value: null,
    description: "Filtering after getting the lookup list",
    type: ComponentElementPropertyType.LOOKUPFILTER
};

export const LookUpAPIFilterKeyConstant = "___lookupAPIFilter";
export const LookUpAPIFilterConstant = {
    label: "Search Filter",
    value: null,
    description: "Filter to request a lookup list",
    type: ComponentElementPropertyType.LOOKUPAPIFILTER
};

export const LookUpAddKeyConstant = "___lookupAdd";
export const LookUpAddConstant = {
    label: "Add value to lookup Data",
    description: "Automatically added to the lookup data when there is no lookup corresponding to the value",
    value: true,
    type: ComponentElementPropertyType.BOOLEAN
};

export const LookUpSearchFieldKeyConstant = "___lookupSearchField";
export const LookUpSearchField = {
    label: "Search Field",
    description: "Search Field (label, label + value, value)",
    value: AutoCompleteSearchField.LABEL,
    lookUpData: LookUpAutoCompleteSearchField
};

export const LookUpLabelKeyConstant = "___lookupLabel";
export const LookUpLabelConstant = {
    label: "Edit Label",
    description: "Editing Label",
    value: "",
    type: ComponentElementPropertyType.LOOKUPLABEL
};
